import { MutationTree } from "vuex";
import { TrnState } from "../types";

const mutations: MutationTree<TrnState> = {
  setTrn(state, trn: string) {
    state.trn = trn;
  },
};

export default mutations;
